import { render, staticRenderFns } from "./JuegosInscritos.vue?vue&type=template&id=6a8c75a8&"
import script from "./JuegosInscritos.vue?vue&type=script&lang=js&"
export * from "./JuegosInscritos.vue?vue&type=script&lang=js&"
import style0 from "./JuegosInscritos.vue?vue&type=style&index=0&id=6a8c75a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports